export default __webpack_public_path__ + "static/media/dash.5344f8d7.png";